import React, {useEffect} from 'react';
import ReactDOM from "react-dom/client";
import {Provider, useDispatch, useSelector} from 'react-redux';
import {Route, Routes, useNavigate} from 'react-router-dom';
import {HistoryRouter} from "redux-first-history/rr6";
import {PersistGate} from 'redux-persist/integration/react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import 'semantic-ui-css/semantic.min.css';
import translations from '../src/components/LanguageModal/translations';

import {persistor, routerHistory, store} from './configureStore';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

import Home from './views/Home';
import Categories from './views/Categories';
import Cart from './views/Cart';
import Search from './views/Search';

import './index.css';

import { closeMenu, closeSearch } from "./features/ui";
import { selectSearchVisible, selectMenuVisible } from "./features/ui/selectors";
import { selectToken, selectUser, selectIsLoggedIn } from "./features/auth/selectors";
import { selectLocation } from "./features/geolocation/selectors";
import {useMixpanel} from "react-mixpanel-browser";
import {isArray} from "lodash";
import ProductsCategory from "./views/ProductsCategory";
import ProductPage from "./views/ProductPage";
import Profile from "./views/Profile";
import SellerPage from "./views/SellerPage";
import Favorite from "./views/Favorite";
import OrderSuccess from "./views/OrderSuccess";
import OrderDetail from "./views/OrderDetail";
import OrderFailure from "./views/OrderFailure";
import PrivacyPolicy from "./views/PrivacyPolicy";
import LegalInfo from "./views/LegalInfo";
import PaymentDelivery from "./views/PaymentDelivery";
import LoyaltyProgram from "./views/LoyaltyProgram";
import FeedLab from "./views/FeedLab";
import RationCalculation from "./views/RationCalculation";
import AuditFarm from "./views/AuditFarm";
import VetLab from "./views/VetLab";
import NotFound from "./views/NotFound";
import ProtectedRoute from "./components/ProtectedRoute";

const root = ReactDOM.createRoot(document.getElementById("root"));

// console.log(`App "${process.enve,.REACT_APP_NAME}" version ${process.env.REACT_APP_VERSION} API Backend ${process.env.REACT_APP_API_URL} is running in ${process.env.REACT_APP_ENV} mode`)

const withRouter = (Component) => (props) => {

    const router = useSelector((state) => state.router);

    const defaultProps = {
        navigate: useNavigate(),
        dispatch: useDispatch(),
        searchVisible: useSelector(selectSearchVisible),
        menuVisible: useSelector(selectMenuVisible),
        userData: useSelector(selectUser),
        userLocation: useSelector(selectLocation),
        isLoggedIn: useSelector(selectIsLoggedIn),
        token: useSelector(selectToken),
        mixpanel: useMixpanel(),
        routeAction: router.action,
        location: router.location,
        previousLocations: router.previousLocations,
        isPageReloaded: router.action === 'POP' && isArray(router.previousLocations) && _.size(router.previousLocations) === 1,
    }
    const {menuVisible, searchVisible, dispatch} = defaultProps;

    useEffect(() => {
        window.scrollTo(0, 0);
        if (menuVisible)
            dispatch(closeMenu());

        if (searchVisible)
            dispatch(closeSearch());
    }, [router.location?.pathname]);

    return <Component {...defaultProps}/>;
}

root.render(
  <Provider store={store}>
    <PersistGate loading={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><Spin indicator={<LoadingOutlined spin style={{ fontSize: 32 }} />} /></div>} persistor={persistor}>
      <HistoryRouter history={routerHistory}>
        <App>
          <Routes>
              <Route exact path={`/`} Component={withRouter(Home)} />
              <Route path={`/products/:categId`} Component={withRouter(ProductsCategory)} />
              <Route path={`/product/:productId`} Component={withRouter(ProductPage)} />
              <Route path={`/categories/:categId`} Component={withRouter(Categories)} />
              <Route path={`/search`} Component={withRouter(Search)} />
              <Route path={`/cart`} Component={withRouter(Cart)} />
              <Route path={`/order-success/:orderId`} Component={withRouter(OrderSuccess)} />
              <Route path={`/order-success`} Component={withRouter(OrderSuccess)} />
              <Route path={`/order-detail/:orderId`} Component={withRouter(OrderDetail)} />
              <Route path={`/order-failure/:orderId`} Component={withRouter(OrderFailure)} />
              <Route path={`/order-failure`} Component={withRouter(OrderFailure)} />
              <Route path={`/order-error/:orderId`} Component={withRouter(OrderFailure)} />
              <Route path={`/order-error`} Component={withRouter(OrderFailure)} />
              <Route path={`/profile`} element={<ProtectedRoute>{React.createElement(withRouter(Profile))}</ProtectedRoute>} />
              <Route path={`/seller/:selId`} Component={withRouter(SellerPage)} />
              <Route path={`/favorite`} Component={withRouter(Favorite)} />
              <Route path={`/privacy-policy`} Component={withRouter(PrivacyPolicy)} />
              <Route path={`/legal-info`} Component={withRouter(LegalInfo)} />
              <Route path={`/payment-and-delivery`} Component={withRouter(PaymentDelivery)} />
              <Route path={`/loyalty-program`} Component={withRouter(LoyaltyProgram)} />
              <Route path={`/feed-lab`} Component={withRouter(FeedLab)} />
              <Route path={`/calculation-of-the-ration`} Component={withRouter(RationCalculation)} />
              <Route path={`/audit-farm`} Component={withRouter(AuditFarm)} />
              <Route path={`/vet-lab`} Component={withRouter(VetLab)} />
              <Route path="*" Component={withRouter(NotFound)} />
          </Routes>
        </App>
      </HistoryRouter>
    </PersistGate>
  </Provider>
);

//registerServiceWorker();

export default withRouter;

